import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { IncidentsProvider } from "./context/IncidentsContext";
import { AlertsPanelProvider } from "./context/AlertsPanelContext";
import { AuthProvider } from "./context/AuthContext";
import { lightTheme, MeetingProvider } from "amazon-chime-sdk-component-library-react";
import { ThemeProvider } from "styled-components";
import { SelectedAlertProvider } from "./context/SelectedAlertContext";
import { CircleSelectionProvider } from "./context/CircleSelectionContext";
import { GroupProvider } from "./context/GroupContext";
import { Provider } from "react-redux";
import { store } from "./redux/store/rootReducers";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <ThemeProvider theme={lightTheme}>
      <Provider store={store}>
        <AuthProvider>
          <SelectedAlertProvider>
            <IncidentsProvider>
              <GroupProvider>
                <AlertsPanelProvider>
                  <CircleSelectionProvider>
                    <MeetingProvider>
                      <App />
                    </MeetingProvider>
                  </CircleSelectionProvider>
                </AlertsPanelProvider>
              </GroupProvider>
            </IncidentsProvider>
          </SelectedAlertProvider>
        </AuthProvider>
      </Provider>
    </ThemeProvider>
  </BrowserRouter>
);
